import styled from 'styled-components'

const StyledInputContainer = styled.div`
	margin-bottom: 4rem;
`

export default StyledInputContainer
